module.exports = __webpack_public_path__ + "static/media/hero.b110734a.png";